'use client';

import { c as _c } from "react/compiler-runtime";
import { faCheckDouble, faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { md5 } from 'js-md5';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useMemo } from 'react';
import { useCachedUnitProgressSWR } from '~/app/actions/progress';
import StudentLearningObjective from '~/components/studentActivity/learningObjectives/StudentLearningObjective';
function ObjectiveBlock(t0) {
  const $ = _c(31);
  const {
    learningObjectives,
    keywords
  } = t0;
  const t = useTranslations();
  const params = useParams();
  let t1;
  if ($[0] !== params.courseId || $[1] !== params.moduleId || $[2] !== params.unitId) {
    t1 = {
      courseId: params.courseId,
      moduleId: params.moduleId,
      unitId: params.unitId
    };
    $[0] = params.courseId;
    $[1] = params.moduleId;
    $[2] = params.unitId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data,
    isLoading,
    isValidating
  } = useCachedUnitProgressSWR(t1);
  const hasObjectives = learningObjectives && learningObjectives.length > 0;
  const hasKeywords = keywords && keywords.length > 0;
  data?.checkedObjectives;
  let set;
  if ($[4] !== data?.checkedObjectives) {
    set = new Set();
    for (const obj of data?.checkedObjectives ?? []) {
      set.add(obj.objectiveHash);
    }
    $[4] = data?.checkedObjectives;
    $[5] = set;
  } else {
    set = $[5];
  }
  const checkedHashes = set;
  let t2;
  if ($[6] !== checkedHashes) {
    t2 = objectiveText => checkedHashes.has(md5(objectiveText));
    $[6] = checkedHashes;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const isChecked = t2;
  let t3;
  if ($[8] !== data || $[9] !== hasObjectives || $[10] !== isChecked || $[11] !== isLoading || $[12] !== isValidating || $[13] !== learningObjectives || $[14] !== t) {
    const checkedCount = hasObjectives ? learningObjectives.filter(o => isChecked(o.objective)).length : 0;
    const totalCount = hasObjectives ? learningObjectives.length : 0;
    const allChecked = totalCount > 0 && checkedCount === totalCount;
    const disabled = typeof data === "undefined" || isValidating || isLoading;
    t3 = hasObjectives && <><div className="flex items-center justify-between mb-3"><h2 className="text-base sm:text-lg font-semibold text-primary">{t("generic.learningObjectives")}</h2><div className={`flex items-center gap-1.5 text-xs sm:text-sm ${allChecked ? "text-green-700" : "text-gray-500"}`}><FontAwesomeIcon icon={faCheckDouble} className="h-3.5 w-3.5" /><span>{t("generic.nCompletedObjectives", {
              completed: checkedCount,
              available: totalCount
            })}</span></div></div><div className="space-y-1">{learningObjectives.filter(_temp).map(objective => <StudentLearningObjective key={String(objective.id)} disabled={disabled} objectiveId={objective.id as string} objectiveContent={objective.objective} initialChecked={isChecked(objective.objective)} className="gap-3 py-2 leading-5 border-b border-primary-100/20 last:border-b-0" />)}</div></>;
    $[8] = data;
    $[9] = hasObjectives;
    $[10] = isChecked;
    $[11] = isLoading;
    $[12] = isValidating;
    $[13] = learningObjectives;
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const objectivesSection = t3;
  let t4;
  if ($[16] !== hasKeywords || $[17] !== keywords || $[18] !== t) {
    t4 = hasKeywords && <><h2 className="text-base sm:text-lg font-semibold text-primary mb-3">{t("generic.keywords")}</h2><div className="flex flex-col gap-2">{keywords.map(_temp2)}</div></>;
    $[16] = hasKeywords;
    $[17] = keywords;
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const keywordsSection = t4;
  if (hasObjectives && !hasKeywords) {
    let t5;
    if ($[20] !== objectivesSection) {
      t5 = <div className="mt-3 p-3 sm:p-4 bg-primary-100/10 rounded-lg border border-primary-100/20">{objectivesSection}</div>;
      $[20] = objectivesSection;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    return t5;
  }
  if (hasKeywords && !hasObjectives) {
    let t5;
    if ($[22] !== keywordsSection) {
      t5 = <div className="mt-3 p-3 sm:p-4 bg-amber-50 rounded-lg border border-amber-100">{keywordsSection}</div>;
      $[22] = keywordsSection;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    return t5;
  }
  let t5;
  if ($[24] !== objectivesSection) {
    t5 = <div className="lg:col-span-2 p-3 sm:p-4 bg-primary-100/10 rounded-lg border border-primary-100/20">{objectivesSection}</div>;
    $[24] = objectivesSection;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== keywordsSection) {
    t6 = <div className="lg:col-span-1 p-3 sm:p-4 bg-amber-50 rounded-lg border border-amber-100">{keywordsSection}</div>;
    $[26] = keywordsSection;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== t5 || $[29] !== t6) {
    t7 = <div className="mt-3 grid grid-cols-1 lg:grid-cols-3 gap-3 sm:gap-4">{t5}{t6}</div>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
}
function _temp2(keyword, index) {
  const content = <><FontAwesomeIcon icon={faKey} size="sm" className="text-amber-600" /><span className="underline decoration-dotted underline-offset-2">{keyword.name}</span></>;
  if (!keyword.linkUrl) {
    return <span key={index} className="flex items-center gap-2 text-gray-700">{content}</span>;
  }
  return <Link href={keyword.linkUrl} key={index} className="flex items-center gap-2 text-gray-700 hover:text-uzh-blue transition-colors" target="_blank" rel="noopener noreferrer">{content}</Link>;
}
function _temp(o_0) {
  return o_0.id != null;
}
export default ObjectiveBlock;